var _excluded = ["cmsContacts", "contactsAction", "onChange"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { cmsActions } from '../../../../reducers/cms.reducer';
import Select from '../Select.react';
var SelectContact = function SelectContact(_ref) {
  var cmsContacts = _ref.cmsContacts,
    contactsAction = _ref.contactsAction,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    contactsAction({});
  }, []);
  return /*#__PURE__*/React.createElement(Select, _extends({
    options: Object.values(cmsContacts).filter(function (x) {
      return x.contactType !== 'page-item-contact';
    })
    // .filter(x => x.clientApp === app)
    .map(function (x) {
      return {
        sLabel: x.title,
        sValue: x._id
      };
    })
  }, rest, {
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      _onChange(sValue);
    }
  }));
};
var mstp = function mstp(s) {
  var _s$cms;
  return {
    cmsContacts: ((_s$cms = s.cms) === null || _s$cms === void 0 ? void 0 : _s$cms.contacts) || {}
  };
};
var mdtp = {
  contactsAction: cmsActions.contacts
};
export default connect(mstp, mdtp)(SelectContact);